(function (angular, app) {
   "use strict";
    
   // Slider
   angular.module(app.modules.scoring.name)
      .directive(app.modules.scoring.directives.fir, FirDirective);
      
   FirDirective.$inject = ["$timeout"];
   
   function FirDirective($timeout){
      
      var ctrl = this;
      
      return {
         restrict : "A"
         , templateUrl : "app/scoring/directives/fir.html"
         , scope: {
            callback : "&"
         }
         , link : function (scope, element, attrs) {
            
            // ElementId
            var elementId = "";
            var isLoaded = false;

            scope.fir = {
               holeNumber: 0
               , par: 4
               , currentValue: null
               , status : {
                  isopen: false
               }
               , toggled : function(open) {}
               , f: {
                  select : function(v){
                     scope.fir.currentValue = v;

                     var data = {
                        holeNumber: scope.fir.holeNumber
                       , par: scope.fir.par
                       , value: scope.fir.currentValue
                     }
               
                     // parent callback
                     scope.callback()(data);
                  }
                  , toggleDropdown : function($event) {
                     $event.preventDefault();
                     $event.stopPropagation();
                     scope.fir.status.isopen = !scope.fir.status.isopen;
                  }
                  , getDropDownButtonClass: function () {
                     var rv = "lnr lnr-chevron-down"
                     switch (scope.fir.currentValue) {
                        case "Hit":
                           rv = "scic scic-fir hit";
                           break;
                        case "MissedUnspecified":
                           rv = "scic scic-fir miss";
                           break;
                        case "MissedRight":
                           rv = "scic scic-fir right";
                           break;
                        case "MissedLeft":
                           rv = "scic scic-fir left";
                           break;
                        case "MissedShort":
                           rv = "scic scic-fir short";
                           break;
                        case "MissedLong":
                           rv = "scic scic-fir long";
                           break;
                     }
                     return rv;
                  }
               }
            }

            var loadOptions = function (objStr, isUpdate) {

               var newValue = null;
               if (objStr) {
                  var obj = JSON.parse(objStr);
                  if (obj) {
                     if (obj.par) {
                        scope.fir.par = Number(obj.par);
                     }
                     if (obj.holeNumber) {
                        scope.fir.holeNumber = Number(obj.holeNumber);
                     }
                     if (obj.currentValue) {
                        newValue = obj.currentValue;
                     } else {
                        newValue = null;
                     }
                  }
               }

               if (newValue != scope.fir.currentValue) {
                  scope.fir.f.select(newValue);
               }

            }

            // Watch for Change in Options
            attrs.$observe('options', function () {
               var optStr = attrs.options;
               if (optStr != "") {
                  loadOptions(optStr, true);
               }
            });
         }
      }
   }
}(angular, app));
